module.exports = __webpack_public_path__ + "img/41.a873dbda.png";